import React from 'react';
import CwhqIcon from '../../images/projectIcons/cwhq.png';

const Cwhq = (props) => (
  <img src={CwhqIcon} alt="cwhq-logo" style={{ width: '64px', height: '64px' }} {...props} />
);

export default Cwhq;
